module.exports = __webpack_public_path__ + "img/ig.f7f657b1.png";